import * as React from 'react';

/**
 * React context to store the width expanded state of the side-panel.
 */
export const SidePanelExpandableContext = React.createContext<{
    expanded: boolean;
    setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}>({
    expanded: false,
    setExpanded: () => {},
});
